module.exports = __webpack_public_path__ + "img/score-en.2ebb7b61.png";